(function ($) {
  $(document).ready(function ($) {
    $(document).on("change", ".resource", function (e) {
      $("#resource-filter-mobile").submit();
    });
    $("#resource-filter-mobile").submit(function (e) {
      let emptyinputs = $(this)
        .find("input")
        .filter(function () {
          return !$.trim(this.value).length; // get all empty fields
        })
        .prop("disabled", true);
    });

    $(document).on("change", ".normal", function (e) {
      $("#resource-filter-normal").submit();
    });
    $("#resource-filter-normal").submit(function (e) {
      let emptyinputs = $(this)
        .find("input")
        .filter(function () {
          return !$.trim(this.value).length; // get all empty fields
        })
        .prop("disabled", true);
    });
  });
})(jQuery);
